// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__keXUv","selected":"Chip_selected__2tRO-"};